import React from "react";
import { motion } from "framer-motion";
import ButtonNext from "./ButtonNext";

const NilaiOptimum = ({ click }) => {
	return (
		<div className="container-fluid">
			<div>
				<motion.h1
					initial={{ y: 500 }}
					animate={{
						y: 0,
						transition: { duration: 0.5, type: "spring" },
					}}
					exit={{
						y: -500,
						transition: { duration: 0.5, type: "spring", ease: "easeInOut" },
					}}
				>
					<div className="row">
						<div className="col-lg-12">
							<div className="text-center">
								<h1>Nilai Optimum</h1>
							</div>
						</div>
					</div>
				</motion.h1>
				<div className="row">
					<div>
						<div style={{ marginTop: "1rem" }}>
							<ButtonNext click={click} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default NilaiOptimum;
